// extracted by mini-css-extract-plugin
export var boxItems = "_95-1";
export var boxItemsLg = "_95-2";
export var button = "_95-7";
export var buttonLg = "_95-8";
export var filterGroupBox = "_95-0";
export var icon = "_95-3";
export var iconSecondary = "_95-6";
export var iconWrapper = "_95-4";
export var iconWrapperLg = "_95-5";